// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Oaty","rootNoMargin":"styles_rootNoMargin__K92ej"};